module.exports = __webpack_public_path__ + "static/img/dnc.eee1ba3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dnc.jpg
// module id = K3lK
// module chunks = 1